/*
  Limpieza 2026-08-28: se retiro un simulador de carrito en memoria
  (cart = [], updateCart, formatPrice, data-cart-open/dialog/items,
  .add-to-cart) y un interceptor del formulario de contacto que
  llamaba siempre preventDefault() y mostraba un mensaje de exito
  falso (data-contact-form). Eran restos de una maqueta inicial:
  el carrito real usa la pagina nativa de Shopify (/cart, enlaces
  <a href=\"{{ routes.cart_url }}\"> y /cart/change), el formulario de
  producto es un {% form 'product' %} real, y la seccion de contacto
  actual no tiene ningun <form>, solo enlaces (WhatsApp, telefono,
  email). Verificado que ningun elemento real del tema usa esos
  atributos antes de borrar el codigo: dejarlo era un riesgo latente
  (si alguna vez se anade un elemento con esos data-attributes,
  este codigo se reactivaria en silencio y bloquearia el envio real).
*/
const header = document.querySelector("[data-header]");
const menuToggle = document.querySelector("[data-menu-toggle]");
const mobileMenu = document.querySelector("[data-mobile-menu]");
const searchOpen = document.querySelector("[data-search-open]");
const searchClose = document.querySelector("[data-search-close]");
const searchDialog = document.querySelector("[data-search-dialog]");
const searchForm = document.querySelector("[data-search-form]");
const searchInput = document.querySelector("#site-search");
const searchFeedback = document.querySelector("[data-search-feedback]");
const newsletterDialog = document.querySelector("[data-newsletter-dialog]");
const newsletterClose = document.querySelector("[data-newsletter-close]");
const pijamasLaunchDialog = document.querySelector("[data-pijamas-launch-dialog]");
const pijamasLaunchClose = document.querySelector("[data-pijamas-launch-close]");
const sizeGuideDialog = document.querySelector("[data-size-guide-dialog]");
const sizeGuideCloseButtons = document.querySelectorAll("[data-size-guide-close]");
const sizeGuideOpenTriggers = document.querySelectorAll("[data-size-guide-open]");
const sizeGuideTabs = sizeGuideDialog ? [...sizeGuideDialog.querySelectorAll("[data-size-guide-tab]")] : [];
const sizeGuidePanels = sizeGuideDialog ? [...sizeGuideDialog.querySelectorAll("[data-size-guide-panel]")] : [];

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const setHeaderState = () => {
  header?.classList.toggle("is-scrolled", window.scrollY > 24);
};

const closeMenu = () => {
  if (!menuToggle || !mobileMenu) return;
  menuToggle.classList.remove("is-open");
  menuToggle.setAttribute("aria-expanded", "false");
  menuToggle.setAttribute("aria-label", "Abrir menú");
  mobileMenu.classList.remove("is-open");
  document.body.classList.remove("menu-open");
};

const openMenu = () => {
  if (!menuToggle || !mobileMenu) return;
  menuToggle.classList.add("is-open");
  menuToggle.setAttribute("aria-expanded", "true");
  menuToggle.setAttribute("aria-label", "Cerrar menú");
  mobileMenu.classList.add("is-open");
  document.body.classList.add("menu-open");
};

setHeaderState();
window.addEventListener("scroll", setHeaderState, { passive: true });

menuToggle?.addEventListener("click", () => {
  const isOpen = menuToggle.getAttribute("aria-expanded") === "true";
  isOpen ? closeMenu() : openMenu();
});

mobileMenu?.addEventListener("click", (event) => {
  const target = event.target;
  if (target instanceof HTMLAnchorElement) {
    closeMenu();
  }
});

const getHashTarget = (hash) => {
  if (!hash || hash === "#") return null;

  try {
    return document.querySelector(hash);
  } catch {
    return null;
  }
};

const revealProductPanelFor = (target) => {
  if (!(target instanceof Element)) return;

  const panel = target.matches("[data-product-panel]") ? target : target.closest("[data-product-panel]");
  if (!(panel instanceof HTMLElement)) return;

  panel.hidden = false;
  panel.classList.add("is-visible");
  panel.querySelectorAll(".reveal").forEach((element) => element.classList.add("is-visible"));
};

const revealCurrentHashPanel = () => {
  const target = getHashTarget(window.location.hash);
  if (target) revealProductPanelFor(target);
};

document.addEventListener("click", (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const link = target.closest('a[href^="#"]');
  if (!(link instanceof HTMLAnchorElement)) return;

  const href = link.getAttribute("href");
  const hashTarget = getHashTarget(href);
  if (!hashTarget) return;

  event.preventDefault();
  revealProductPanelFor(hashTarget);
  closeMenu();
  history.pushState(null, "", href);
  hashTarget.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth", block: "start" });
});

window.addEventListener("hashchange", revealCurrentHashPanel);
window.addEventListener("load", revealCurrentHashPanel);

window.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    closeMenu();
    if (searchDialog?.open) {
      searchDialog.close();
      document.body.classList.remove("dialog-open");
    }
    if (newsletterDialog?.open) {
      newsletterDialog.close();
      document.body.classList.remove("dialog-open");
    }
    if (pijamasLaunchDialog?.open) {
      pijamasLaunchDialog.close();
      document.body.classList.remove("dialog-open");
    }
    if (sizeGuideDialog?.open) {
      sizeGuideDialog.close();
      document.body.classList.remove("dialog-open");
    }
  }
});

const showSizeGuideTab = (category) => {
  if (!sizeGuideTabs.length) return;
  const hasCategory = sizeGuideTabs.some((tab) => tab.dataset.sizeGuideTab === category);
  const target = hasCategory ? category : sizeGuideTabs[0].dataset.sizeGuideTab;

  sizeGuideTabs.forEach((tab) => {
    const isActive = tab.dataset.sizeGuideTab === target;
    tab.classList.toggle("is-active", isActive);
    tab.setAttribute("aria-selected", isActive ? "true" : "false");
    tab.tabIndex = isActive ? 0 : -1;
  });

  sizeGuidePanels.forEach((panel) => {
    panel.hidden = panel.dataset.sizeGuidePanel !== target;
  });
};

sizeGuideOpenTriggers.forEach((trigger) => trigger.addEventListener("click", () => {
  if (!sizeGuideDialog) return;
  showSizeGuideTab(trigger.dataset.sizeGuideCategory || "mujer");
  if (typeof sizeGuideDialog.showModal === "function") {
    sizeGuideDialog.showModal();
    document.body.classList.add("dialog-open");
  }
}));

sizeGuideCloseButtons.forEach((button) => button.addEventListener("click", () => {
  sizeGuideDialog?.close();
}));

sizeGuideDialog?.addEventListener("close", () => {
  document.body.classList.remove("dialog-open");
});

sizeGuideDialog?.addEventListener("click", (event) => {
  if (event.target === sizeGuideDialog) {
    sizeGuideDialog.close();
  }
});

sizeGuideTabs.forEach((tab) => tab.addEventListener("click", () => showSizeGuideTab(tab.dataset.sizeGuideTab)));

sizeGuideDialog?.querySelector('[role="tablist"]')?.addEventListener("keydown", (event) => {
  if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
  const currentIndex = sizeGuideTabs.findIndex((tab) => tab.classList.contains("is-active"));
  const delta = event.key === "ArrowRight" ? 1 : -1;
  const nextTab = sizeGuideTabs[(currentIndex + delta + sizeGuideTabs.length) % sizeGuideTabs.length];
  showSizeGuideTab(nextTab.dataset.sizeGuideTab);
  nextTab.focus();
});

if (!prefersReducedMotion) {
  document.body.classList.add("can-animate");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: "0px 0px -12% 0px", threshold: 0.12 },
  );

  document.querySelectorAll(".reveal").forEach((element) => observer.observe(element));
} else {
  document.querySelectorAll(".reveal").forEach((element) => element.classList.add("is-visible"));
}

searchOpen?.addEventListener("click", () => {
  if (!searchDialog) return;
  if (typeof searchDialog.showModal === "function") {
    searchDialog.showModal();
    document.body.classList.add("dialog-open");
    searchInput?.focus();
  }
});

searchClose?.addEventListener("click", () => {
  searchDialog?.close();
  document.body.classList.remove("dialog-open");
});

searchDialog?.addEventListener("close", () => {
  document.body.classList.remove("dialog-open");
});

searchDialog?.addEventListener("click", (event) => {
  if (event.target === searchDialog) {
    searchDialog.close();
  }
});

const closeNewsletter = () => {
  newsletterDialog?.close();
  document.body.classList.remove("dialog-open");
  try {
    sessionStorage.setItem("lesAmisNewsletterSeen", "true");
  } catch {
    // Ignore unavailable storage.
  }
};

window.addEventListener("load", () => {
  if (!newsletterDialog || typeof newsletterDialog.showModal !== "function") return;

  let alreadySeen = false;
  try {
    alreadySeen = sessionStorage.getItem("lesAmisNewsletterSeen") === "true";
  } catch {
    alreadySeen = false;
  }

  if (!alreadySeen) {
    window.setTimeout(() => {
      if (!newsletterDialog.open) {
        newsletterDialog.showModal();
        document.body.classList.add("dialog-open");
      }
    }, 650);
  }
});

newsletterClose?.addEventListener("click", closeNewsletter);

newsletterDialog?.addEventListener("click", (event) => {
  if (event.target === newsletterDialog) closeNewsletter();
});

const closePijamasLaunch = () => {
  pijamasLaunchDialog?.close();
  document.body.classList.remove("dialog-open");
  try {
    sessionStorage.setItem("lesAmisPijamasLaunchSeen", "true");
  } catch {
    // Ignore unavailable storage.
  }
};

window.addEventListener("load", () => {
  if (!pijamasLaunchDialog || typeof pijamasLaunchDialog.showModal !== "function") return;

  let alreadySeen = false;
  try {
    alreadySeen = sessionStorage.getItem("lesAmisPijamasLaunchSeen") === "true";
  } catch {
    alreadySeen = false;
  }

  if (!alreadySeen) {
    window.setTimeout(() => {
      if (!pijamasLaunchDialog.open && !newsletterDialog?.open) {
        pijamasLaunchDialog.showModal();
        document.body.classList.add("dialog-open");
      }
    }, 800);
  }
});

pijamasLaunchClose?.addEventListener("click", closePijamasLaunch);

pijamasLaunchDialog?.addEventListener("click", (event) => {
  if (event.target === pijamasLaunchDialog) closePijamasLaunch();
});

const searchTargets = [
  { terms: ["elenita"], href: "#producto-elenita" },
  { terms: ["esther"], href: "#producto-esther" },
  { terms: ["estefania", "estefanía"], href: "#producto-estefania" },
  { terms: ["cata"], href: "#producto-cata" },
  { terms: ["alfonso"], href: "#producto-alfonso" },
  { terms: ["carlos"], href: "#producto-carlos" },
  { terms: ["bruno"], href: "#producto-bruno" },
  { terms: ["roman", "román"], href: "#producto-roman" },
  { terms: ["mauro"], href: "#producto-mauro" },
  { terms: ["mario"], href: "#producto-mario" },
  { terms: ["pol"], href: "#producto-pol" },
  { terms: ["tristan", "tristán"], href: "#producto-tristan" },
  { terms: ["gina"], href: "#producto-gina" },
  { terms: ["julieta"], href: "#producto-julieta" },
  { terms: ["maria", "maría"], href: "#producto-maria" },
  { terms: ["sandra arras"], href: "#producto-sandra-arras" },
  { terms: ["cludia", "claudia"], href: "#producto-cludia" },
  { terms: ["ichi"], href: "#producto-ichi" },
  { terms: ["jana"], href: "#producto-jana" },
  { terms: ["carlota"], href: "#producto-carlota" },
  { terms: ["casilda"], href: "#producto-casilda" },
  { terms: ["beatriz"], href: "#producto-beatriz" },
  { terms: ["victoria"], href: "#producto-victoria" },
  { terms: ["capota"], href: "#producto-capota" },
  { terms: ["coronita"], href: "#producto-coronita" },
  { terms: ["pasador"], href: "#producto-pasador" },
  { terms: ["lazada"], href: "#producto-lazada" },
  { terms: ["andrea"], href: "#producto-andrea" },
  { terms: ["gabi"], href: "#producto-gabi" },
  { terms: ["sandra"], href: "#producto-sandra" },
  { terms: ["ines", "inés"], href: "#producto-ines" },
  { terms: ["alejandra"], href: "#producto-alejandra" },
  { terms: ["mencia", "mencía"], href: "#producto-mencia" },
  { terms: ["pia", "pía"], href: "#producto-pia" },
  { terms: ["reyes"], href: "#producto-reyes" },
  { terms: ["americanas"], href: "#producto-americanas" },
  { terms: ["camisas"], href: "#producto-camisas" },
  { terms: ["pantalones"], href: "#producto-pantalones" },
  { terms: ["corbatas"], href: "#producto-corbatas" },
  { terms: ["zapatos"], href: "#producto-zapatos" },
  { terms: ["bautizo"], href: "#bautizo" },
  { terms: ["arras", "boda", "bodas"], href: "#arras" },
  { terms: ["comunion", "comunión", "primera comunion", "primera comunión"], href: "#primera-comunion" },
  { terms: ["comprar", "compra", "tienda", "carrito"], href: "#colecciones" },
  { terms: ["marca", "marcas", "creadores", "produccion", "producción", "co"], href: "#co" },
  { terms: ["colegio", "colegios", "uniformidad", "uniformes"], href: "#colegios" },
  { terms: ["contacto", "cita", "whatsapp", "telefono", "teléfono", "direccion", "dirección"], href: "#contacto" },
];

searchForm?.addEventListener("submit", (event) => {
  event.preventDefault();
  const query = searchInput?.value.trim().toLowerCase() ?? "";

  if (!query) {
    if (searchFeedback) searchFeedback.textContent = "Escribe una colección, modelo o servicio.";
    return;
  }

  const match = searchTargets.find((target) => target.terms.some((term) => query.includes(term)));

  if (!match) {
    if (searchFeedback) searchFeedback.textContent = "No hemos encontrado una coincidencia clara. Te llevamos a contacto.";
    window.location.hash = "#contacto";
  } else {
    if (searchFeedback) searchFeedback.textContent = "Te llevamos a la sección correspondiente.";
    const hashTarget = getHashTarget(match.href);
    if (hashTarget) {
      revealProductPanelFor(hashTarget);
      history.pushState(null, "", match.href);
      hashTarget.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth", block: "start" });
    } else {
      window.location.hash = match.href;
    }
  }

  window.setTimeout(() => {
    searchDialog?.close();
    document.body.classList.remove("dialog-open");
  }, 320);
});